import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-status-box',
  templateUrl: './status-box.component.html',
  styleUrls: ['./status-box.component.scss']
})
export class StatusBoxComponent extends BaseComponent implements OnInit {

  private _pidInterval:number = null;
  status:any;
  loaded:boolean = false;

  private _boxService;

  ngOnInit(): void {
  	if (!this.localSession.isInitialized()) {
  		console.log("Disconnected");
  	}

  	this.boxService
        .getMessagesStatus()
        .subscribe((msg: any) => { });

    // this._pidInterval = setInterval(() => {
    // 	this.status = this.boxService.updateStatus();
    // 	this.loaded = this.status != undefined && this.localSession.isSocketConnected();

    // }, 1000);

  }

  ngOnDestroy(): void{
  	clearInterval(this._pidInterval);
  }

  openBox() :void{
  	this.boxService.open();
  }

  closeBox() :void{
  	this.boxService.close();
  }

  openBackDoorBox() :void{
  	this.boxService.openBackDoor();
  }

  forceStopBox() :void{
  	this.boxService.forceStop();
  }

  gotoIdle() : void{
  	this.boxService.gotoIdleScreen();
  }

  gotoBlack() : void{
  	this.boxService.gotoBlackScreen();
  }

  gotoReady() : void{
  	this.boxService.gotoReadyScreen();
  }

  viewVideo() : void{
  	this.boxService.viewVideo();
  }
}
